export const getPhysicalAppearanceDetailsList = (physicalData = {}) => [
  {
    label: "Weight",
    value: physicalData.weight ?? "",
  },
  {
    label: "Height",
    value: physicalData.height ?? "",
  },
  {
    label: "Blood Group",
    value: physicalData.blood_group || null,
  },
  {
    label: "Complexion",
    value: physicalData.complexion || null,
  },
  {
    label: "Body Type",
    value: physicalData.body_type || null,
  },
  {
    label: "Physical Status",
    value: physicalData.physical_status || null,
  },
];
